import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import type { Tariff, TariffDetail, TariffFormData } from './types';

export async function fetchTariffs(forOper: string = '1'): Promise<Tariff[]> {
  const { data } = await apiClient.get<ApiResponse<Tariff[]>>(`/api/tariffs/list/${forOper}`);
  if (!data.success) throw new Error('Не удалось загрузить тарифы');
  return data.response ?? [];
}

export async function fetchTariff(id: number): Promise<TariffDetail> {
  const { data } = await apiClient.get<ApiResponse<TariffDetail[]>>(`/api/tariffs/${id}`);
  if (!data.success) throw new Error('Не удалось загрузить тариф');
  const detail = data.response?.[0];
  if (!detail) throw new Error('Тариф не найден');
  return detail;
}

export async function createTariff(formData: TariffFormData): Promise<number> {
  const { data } = await apiClient.post<ApiResponse<number>>(
    '/api/tariffs',
    formDataToPayload(formData)
  );
  if (!data.success) throw new Error('Не удалось создать тариф');
  return data.response ?? 0;
}

export async function updateTariff(id: number, formData: TariffFormData): Promise<number> {
  const { data } = await apiClient.put<ApiResponse<number>>(
    `/api/tariffs/${id}`,
    formDataToPayload(formData)
  );
  if (!data.success) throw new Error('Не удалось обновить тариф');
  return data.response ?? 0;
}

export async function deleteTariff(id: number): Promise<number> {
  const { data } = await apiClient.delete<ApiResponse<number>>(`/api/tariffs/${id}`);
  if (!data.success) throw new Error('Не удалось удалить тариф');
  return data.response ?? 0;
}

export function toIntOrNull(s: string): number | null {
  if (s.trim() === '') return null;
  const n = parseInt(s, 10);
  return Number.isNaN(n) ? null : n;
}

export function formDataToPayload(data: TariffFormData) {
  return {
    tariff_name: data.tariff_name,
    ab_plata: parseInt(data.ab_plata) || 0,
    description: data.description,
    id_country: parseInt(data.id_country) || 0,
    id_account_type: parseInt(data.id_account_type) || 0,
    id_archive_period: parseInt(data.id_archive_period) || 0,
    test_days: parseInt(data.test_days) || 0,
    tariff_length: toIntOrNull(data.tariff_length) || null,
    is_showed: data.is_showed ? 1 : 0,
    for_oper: data.for_oper ? 1 : 0,
    is_start: parseInt(data.is_start) || 0,
    id_tariff_vc: toIntOrNull(data.id_tariff_vc),
    users_choice: data.users_choice ? 1 : 0,
    periods_count: toIntOrNull(data.periods_count),
    show_if_count_abon_cameras_is: toIntOrNull(data.show_if_count_abon_cameras_is),
    has_discount: data.has_discount ? 1 : 0,
    bonus_days: toIntOrNull(data.bonus_days),
    id_tariff_after_bonus: toIntOrNull(data.id_tariff_after_bonus),
    for_move: data.for_move ? 1 : 0,
    is_tariff_lv_monitor: data.is_tariff_lv_monitor ? 1 : 0,
    start_tariff_lv_monitor: toIntOrNull(data.start_tariff_lv_monitor),
    no_show_tariff_with_location: data.no_show_tariff_with_location ? 1 : 0,
    account_description: data.account_description,
    desc_recomm_pay: data.desc_recomm_pay,
  };
}
